import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref } from 'vue';
import Layout from '@/layout/index.vue';
import beaconSDK from '@/utils/report';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    beaconSDK.sdkReport('page_visit');
    var locale = ref({
      name: 'zh-cn',
      el: {
        table: {
          emptyText: '暂无数据'
        },
        select: {
          noData: '暂无数据',
          noMatch: '暂无数据'
        },
        popconfirm: {
          cancelButtonText: '取消',
          confirmButtonText: '确定'
        },
        pagination: {
          total: '总计',
          goto: '跳至',
          pagesize: '条/页',
          pageClassifier: '页'
        },
        datepicker: {
          months: {
            jan: '一月',
            feb: '二月',
            mar: '三月',
            apr: '四月',
            may: '五月',
            jun: '六月',
            jul: '七月',
            aug: '八月',
            sep: '九月',
            oct: '十月',
            nov: '十一月',
            dec: '十二月'
          },
          weeks: {
            sun: '日',
            mon: '一',
            tue: '二',
            wed: '三',
            thu: '四',
            fri: '五',
            sat: '六'
          },
          year: '年',
          month1: '1月',
          month2: '2月',
          month3: '3月',
          month4: '4月',
          month5: '5月',
          month6: '6月',
          month7: '7月',
          month8: '8月',
          month9: '9月',
          month10: '10月',
          month11: '11月',
          month12: '12月'
        }
      }
    });
    var value1 = ref('');
    return function (_ctx, _cache) {
      var _component_el_config_provider = _resolveComponent("el-config-provider");

      return _openBlock(), _createBlock(_component_el_config_provider, {
        locale: locale.value
      }, {
        default: _withCtx(function () {
          return [_createVNode(Layout)];
        }),
        _: 1
      }, 8, ["locale"]);
    };
  }
});